export default {
  maxHistory: 3,
  matches: [],
  filters: {
    companies: [],
    signals: []
  }
};
